module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m_context"
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-left": "24px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": _vm.typeChange
    },
    model: {
      value: (_vm.selectType),
      callback: function($$v) {
        _vm.selectType = $$v
      },
      expression: "selectType"
    }
  }, _vm._l((_vm.type), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('lin_global.tgmccz'),
      "icon": "search",
      "on-icon-click": _vm.handleIconClick
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "arrdata",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.arrdata,
      "id": "tp",
      "border": ""
    },
    on: {
      "row-click": _vm.rowClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('lin_global.name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": _vm.$t('lin_global.version'),
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": _vm.$t('terminal.details.animatType'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechanismName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "opetime",
      "label": _vm.$t('lin_global.uploadTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "align": "center",
      "width": "",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_verify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('i', {
          staticClass: "fa fa-check-square-o"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.totalRecords > 0) ? _c('div', {
    staticClass: "page_content"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26e7a2b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/romReview.vue
// module id = 995
// module chunks = 0